export default __webpack_public_path__ + "static/media/work.ffd156e3.png";